<template>
  <div class="filters-container">
    <div class="filters-grid">
      <div class="filter-field">
        <label class="filter-label">Pré Pedido</label>
        <input
          type="number"
          v-model="filtersData.prePedido"
          placeholder="Número"
          class="filter-input"
        />
      </div>

      <div class="filter-field">
        <label class="filter-label">Pedido ERP</label>
        <input
          v-model="filtersData.pedidoErp"
          placeholder="Número ERP"
          class="filter-input"
        />
      </div>

      <div class="filter-field">
        <label class="filter-label">Cliente</label>
        <input
          type="number"
          v-model="filtersData.cliente"
          placeholder="ID Cliente"
          class="filter-input"
        />
      </div>

      <div class="filter-field filter-field-wide">
        <label class="filter-label">Razão Social</label>
        <input
          type="text"
          v-model="filtersData.razaoSocial"
          placeholder="Nome do cliente"
          class="filter-input"
        />
      </div>

      <div class="filter-field">
        <label class="filter-label">Status</label>
        <select v-model="selected" class="filter-select">
          <option :value="null">Todos</option>
          <option value="CANCELADO">Cancelado</option>
          <option value="DIGITADO">Digitado</option>
          <option value="EXCLUÌDO">Excluído</option>
          <option value="INTEGRADO">Integrado</option>
          <option value="RECALCULAR">Recalcular</option>
          <option value="REJEITADO">Rejeitado</option>
          <option value="APROVADO">Aprovado</option>
        </select>
      </div>

      <div class="filter-field">
        <label class="filter-label">Data Inicial</label>
        <input
          v-model="filtersData.dataInicial"
          type="date"
          class="filter-input"
        />
      </div>

      <div class="filter-field">
        <label class="filter-label">Data Final</label>
        <input
          v-model="filtersData.dataFinal"
          type="date"
          class="filter-input"
        />
      </div>
    </div>

    <div class="filters-actions">
      <button class="btn-filter btn-primary" @click="emitSearch">
        <feather-icon icon="SearchIcon" size="16" />
        <span>Pesquisar</span>
      </button>
      <button class="btn-filter btn-secondary" @click="clearFilters">
        <feather-icon icon="RefreshCwIcon" size="16" />
        <span>Limpar</span>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapActions } from 'vuex';

moment.tz.setDefault('America/Sao_Paulo');

export default {
  data() {
    return {
      selected: null,
      nameUser: null,
      userOptions: [],
      filtersData: {
        dataInicial: '',
        dataFinal: '',
        prePedido: null,
        cliente: null,
        nrPedido: null,
        nrNota: null,
        razaoSocial: '',
        pedidoErp: null,
      },
    };
  },
  methods: {
    ...mapActions('SLS_PedidosVendas', { clearFiltersAction: 'clearFilters' }),
    async emitSearch() {
      if (this.selected !== null && this.selected !== '') {
        this.filtersData.status = this.selected;
      }
      if (this.filtersData.prePedido === null || this.filtersData.prePedido === '') {
        delete this.filtersData.prePedido;
      }
      if (this.filtersData.cliente === null || this.filtersData.cliente === '') {
        delete this.filtersData.cliente;
      }
      if (this.filtersData.nrPedido === null || this.filtersData.nrPedido === '') {
        delete this.filtersData.nrPedido;
      }
      if (this.filtersData.nrNota === null || this.filtersData.nrNota === '') {
        delete this.filtersData.nrNota;
      }
      if (this.filtersData.dataInicial === null || this.filtersData.dataInicial === '') {
        delete this.filtersData.dataInicial;
      }
      if (this.filtersData.dataFinal === null || this.filtersData.dataFinal === '') {
        delete this.filtersData.dataFinal;
      }
      if (this.filtersData.razaoSocial === null || this.filtersData.razaoSocial === '') {
        delete this.filtersData.razaoSocial;
      }
      console.log(this.filtersData);
      await this.$emit('search', this.filtersData);
    },
    async clearFilters() {
      console.log('CLEAR FILTER');
      await this.clearFiltersAction();

      this.filtersData = {
        dataInicial: '',
        dataFinal: '',
        prePedido: null,
        cliente: null,
        nrPedido: null,
        nrNota: null,
        razaoSocial: '',
        pedidoErp: null,
      };
      this.selected = null;
      await this.emitSearch();
    },
  },
  async created() {
    await this.emitSearch();
  },
  computed: {
    ...mapGetters({
      userAuth: 'auth/GET_USER',
    }),
  },
  mounted() {
    this.userOptions.push({ value: null, text: this.userAuth.nome, disabled: true });
  },
};
</script>

<style scoped>
.filters-container {
  padding: 0;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem 1.5rem;
  margin-bottom: 1.5rem;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.filter-field-wide {
  grid-column: span 2;
}

.filter-label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-secondary, #64748b);
  margin: 0;
  letter-spacing: 0.01em;
}

.filter-input,
.filter-select {
  height: 40px;
  padding: 0.5rem 0.875rem;
  font-size: 0.875rem;
  color: var(--text-primary, #1e293b);
  background: var(--input-bg, #ffffff);
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: 8px;
  transition: all 0.15s ease;
  outline: none;
  width: 100%;
}

.filter-input::placeholder {
  color: var(--text-muted, #94a3b8);
}

.filter-input:hover,
.filter-select:hover {
  border-color: var(--border-hover, #cbd5e1);
}

.filter-input:focus,
.filter-select:focus {
  border-color: var(--primary, #7c3aed);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

.filter-select {
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  padding-right: 2.5rem;
}

.filters-actions {
  display: flex;
  gap: 0.75rem;
  padding-top: 0.5rem;
}

.btn-filter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-primary {
  background: var(--primary, #7c3aed);
  color: #ffffff;
}

.btn-primary:hover {
  background: var(--primary-dark, #6d28d9);
  transform: translateY(-1px);
}

.btn-secondary {
  background: var(--bg-secondary, #f1f5f9);
  color: var(--text-secondary, #64748b);
  border: 1px solid var(--border-color, #e2e8f0);
}

.btn-secondary:hover {
  background: var(--bg-tertiary, #e2e8f0);
  color: var(--text-primary, #1e293b);
}

@media (max-width: 1024px) {
  .filters-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .filter-field-wide {
    grid-column: span 2;
  }
}

@media (max-width: 640px) {
  .filters-grid {
    grid-template-columns: 1fr;
    gap: 0.875rem;
  }

  .filter-field-wide {
    grid-column: span 1;
  }

  .filters-actions {
    flex-direction: column;
  }

  .btn-filter {
    width: 100%;
  }
}

body.dark-layout .filter-input,
body.dark-layout .filter-select {
  background: var(--dark-input-bg, #283046);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-primary, #d0d2d6);
}

body.dark-layout .filter-input::placeholder {
  color: var(--dark-text-muted, #676d7d);
}

body.dark-layout .filter-input:focus,
body.dark-layout .filter-select:focus {
  border-color: var(--primary, #7c3aed);
}

body.dark-layout .btn-secondary {
  background: var(--dark-bg-secondary, #283046);
  border-color: var(--dark-border, #3b4253);
  color: var(--dark-text-secondary, #b4b7bd);
}

body.dark-layout .btn-secondary:hover {
  background: var(--dark-bg-tertiary, #343d55);
}

body.dark-layout .filter-label {
  color: var(--dark-text-secondary, #b4b7bd);
}

body.dark-layout .filter-select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23676d7d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
}
</style>
